module.exports = __webpack_public_path__ + "files/0447bd40d3834bb377fef196f45ec6cb.png";